import { AvailableTabs } from 'constants/SidebarTabs';
import { NormalizedLoad } from 'types/Load';

import { getCurrentUrl } from './current-url';
import { TMSHost } from './interface';

function isTransportProUrl(urlString: string): boolean {
  try {
    const url = new URL(urlString);
    return url.hostname.endsWith('.transportpro.net');
  } catch {
    return false;
  }
}

function extractLoadIdFromOnclick(onclick: string): string {
  return (
    onclick.match(/(?:^|[?&'"])loadId=(\d+)(?:[&'"]|$)/)?.[1] ??
    onclick.match(/(?:^|[?&'"])id=(\d+)(?:[&'"]|$)/)?.[1] ??
    ''
  );
}

function extractLoadIdFromUrl(urlString: string): string {
  try {
    const url = new URL(urlString);
    const isSummaryDispatchUrl =
      url.pathname.includes('summaryDispatch') ||
      url.hash.includes('summaryDispatch');

    if (!isSummaryDispatchUrl) {
      return '';
    }

    const hashParams = new URLSearchParams(url.hash.split('?')[1] ?? '');

    return (
      url.searchParams.get('loadId') ??
      url.searchParams.get('id') ??
      hashParams.get('loadId') ??
      hashParams.get('id') ??
      ''
    );
  } catch {
    return '';
  }
}

function parseTransportProLoadFromDom(): string {
  if (typeof document === 'undefined') {
    return '';
  }

  const loadSummaryLink = document.querySelector<HTMLElement>(
    '[name="hoverDivContent"] a[onclick*="summaryDispatch.php"][onclick*="id="]'
  );
  const loadSummaryOnclick = loadSummaryLink?.getAttribute('onclick') ?? '';
  const loadIdFromLoadSummaryLink =
    extractLoadIdFromOnclick(loadSummaryOnclick);
  if (loadIdFromLoadSummaryLink) {
    return loadIdFromLoadSummaryLink;
  }

  const selectedLoadHeader =
    document
      .querySelector<HTMLElement>(
        '[name="hoverDivContent"] [style*="font-weight: bold"]'
      )
      ?.textContent?.trim() ?? '';
  const loadIdFromHeader = selectedLoadHeader.match(/^(\d+)\s*-/)?.[1] ?? '';
  if (loadIdFromHeader) {
    return loadIdFromHeader;
  }

  const loadIdInput = document.querySelector<HTMLInputElement>(
    '[name="hoverDivContent"] input[name="id"], [name="hoverDivContent"] input[name="loadId"]'
  );
  const loadIdFromInput = loadIdInput?.value?.trim() ?? '';
  if (loadIdFromInput) {
    return loadIdFromInput;
  }

  const summaryLoadIdLabel = Array.from(
    document.querySelectorAll<HTMLElement>('#summaryLoadInfoDiv td')
  ).find((cell) => cell.textContent?.trim() === 'Load ID');
  const loadIdFromSummaryTable =
    summaryLoadIdLabel?.nextElementSibling?.textContent?.trim() ?? '';
  if (/^\d+$/.test(loadIdFromSummaryTable)) {
    return loadIdFromSummaryTable;
  }

  return '';
}

export class TransportPro implements TMSHost {
  private getCurrentUrl: () => string;

  constructor(getCurrentUrlFn?: () => string) {
    this.getCurrentUrl = getCurrentUrlFn || getCurrentUrl;
  }

  getFieldMoniker(key: keyof NormalizedLoad): string {
    return key === 'freightTrackingID' ? 'Load ID' : '';
  }

  parseFreightTrackingID(): string {
    return (
      parseTransportProLoadFromDom() ||
      extractLoadIdFromUrl(this.getCurrentUrl())
    );
  }

  parseExternalTMSID(): string {
    return this.parseFreightTrackingID();
  }

  determineDefaultLoadTab(): AvailableTabs {
    return AvailableTabs.LoadInformation;
  }

  shouldShowDrumkitOpener(): boolean {
    const url = this.getCurrentUrl();
    return isTransportProUrl(url);
  }
}
